import { gql } from '@eti/schema-types';

export const ADD_TO_ADDON_CART = gql(/* GraphQL */ `
  mutation addToAddonCart($tripId: ID!, $extraProductSelection: [ExtraProductSelectionInput]!) {
    addToAddonCart(tripId: $tripId, extraProductSelection: $extraProductSelection) {
      success
    }
  }
`);

export const EMPTY_ADDON_CART_MUTATION = gql(/* GraphQL */ `
  mutation emptyAddOnCart {
    emptyAddOnCart {
      success
    }
  }
`);
